import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ReceiptCreate = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        SaleDate: '',
        ReferenceNo: 0,
        PartyId: '',
        PackingListId: '',
        TotalBilledQuantity: 0,
        TotalBilledAmount: 0,
        Remarks: '',
        Packinglistdeatils: '',
        PaymentType: 0,
        createdBy: userId,
        isSubmit: false,
        BalBox: 0,
        Box: 0,
        TotalBalAmt: 0,
    });

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            PartyId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (selectedOption) {
            fetchData('ReceiptApi', `/PartyReceiptBill/${selectedOption.value}/${companyId}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {

                        const updatedInvoicedetailsSorted = response.response_data;

                        const totalSaleAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                            return total + invdetail.SaleAmount;
                        }, 0);

                        // Update formData with total SaleAmount
                        setFormData((prevData) => ({
                            ...prevData,
                            TotalBalAmt: totalSaleAmount,
                        }));

                        setInvoicedeatils(updatedInvoicedetailsSorted);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });
        }

    };


    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('ReceiptApi', `/Party/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((customer) => ({
                    label: customer.CustomerName,
                    value: customer.ID,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };



    const submitData = async (e) => {
        setIsLoading(true);

        if (!formData.PartyId || formData.PartyId === 0) {
            setErrorMessage('Customer is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
        }));

        const createData = {
            PaymentAndReceipt: formData,
            PaymentAndReceiptSale: invoicedeatils,
        };

        postData('ReceiptApi', createData, token)
            .then((response) => {
                setSuccessMessage('Receipt Created successfully!');
                setErrorMessage('');

                history.push('/ReceiptIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);

            })
            .catch((error) => {
                console.error('Receipt Create error:', error);
                setIsLoading(false);
            });

    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'Amount') {
            let newAmount = parseFloat(value);
            if (isNaN(newAmount)) {
                newAmount = 0;
            }

            // Ensure the entered amount does not exceed formData.TotalBalAmt
            const restrictedAmount = Math.min(newAmount, formData.TotalBalAmt);

            // Update formData with the restricted amount value
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : restrictedAmount,
            }));

            // Initialize remaining balance to the restricted amount
            let remainingBalance = restrictedAmount;

            // Loop through each row in invoicedeatils
            const updatedInvoicedeatils = invoicedeatils.map((invdetail) => {
                // Calculate the amount for this row (minimum of SaleAmount and remaining balance)
                const amountForThisRow = Math.min(invdetail.SaleAmount, remainingBalance);

                // Update the remaining balance
                remainingBalance -= amountForThisRow;

                // Ensure invdetail.Amount does not exceed invdetail.SaleAmount
                const updatedAmount = Math.min(amountForThisRow, invdetail.SaleAmount);

                // Calculate the balance amount for this row (ensure it's not negative)
                const balanceForThisRow = Math.max(invdetail.SaleAmount - updatedAmount, 0);

                // Return the updated row
                return {
                    ...invdetail,
                    Amount: updatedAmount,
                    BalanceAmount: balanceForThisRow,
                };
            });

            // Update invoicedeatils with the updated values
            setInvoicedeatils(updatedInvoicedeatils);
        } else if (name === 'PaymentType') {
            // Handle changes for the Payment Type radio buttons
            const newPaymentType = value;

            setSelectedPaymentType(newPaymentType);

            setFormData((prevData) => ({
                ...prevData,
                PaymentType: newPaymentType,
            }));
        }
        else {
            // For other form fields, update formData directly
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            ReferenceDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '900px', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                        
                    `}
                </style>


                <div className=" rounded-lg shadow-lg p-2">

                    <div className='w-full flex'>
                        <div className="banner-style" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '8px', width: '100%' }}>
                            <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CREATE  RECEIPT</h6>

                            <Link to="/ReceiptIndex" style={{ marginTop: '-30px', color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List  <ArrowForwardIosIcon />
                                </Button>
                            </Link>


                            <Button onClick={submitData} style={{ marginTop: '-30px', color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit"} <CheckCircleIcon />
                            </Button>



                        </div>

                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0"> {/* Adjusted width for smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="customer">
                                Customer
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={customerOptions}
                                value={selectedCustomer}
                                onChange={handleCustomerSelect}
                                placeholder="Select a customer"
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Reference Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ReferenceDate)}
                                type="date"
                                placeholder="Enter Reference Date"
                                name='ReferenceDate'
                                readOnly
                                onChange={handleChange}
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Reference No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ReferenceNo}
                                type="text"
                                placeholder="Enter Reference No"
                                readOnly
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="rate">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Remarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remarks"
                                name='Remarks'
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Amount}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='Amount'
                                max={formData.TotalBalAmt}
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pr-2 mb-2 sm:mb-0">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2">
                                Payment Type
                            </label>
                            <div className="flex items-center">
                                <label className="block  tracking-wide text-gray-700  font-bold mr-2">
                                    <input type="radio" name="PaymentType" value="1"
                                        checked={selectedPaymentType === "1"}
                                        onChange={handleChange} />
                                    Cash
                                </label>
                                <label className="block  tracking-wide text-gray-700  font-bold mr-2">
                                    <input type="radio" name="PaymentType" value="2"
                                        checked={selectedPaymentType === "2"}
                                        onChange={handleChange} />
                                    Cheque
                                </label>
                                <label className='block  tracking-wide text-gray-700  font-bold'>
                                    <input type="radio" name="PaymentType" value="3"
                                        checked={selectedPaymentType === "3"}
                                        onChange={handleChange} />
                                    UPI
                                </label>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="rounded-lg shadow-lg p-2" style={{ marginTop: '10px' }}>
                    <div className="w-full mb-2 flex">
                        <div className="w-full mb-2 flex">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '8px', textAlign: 'center' }}>Sale Bill Details</th>
                                            <th style={{ padding: '8px', textAlign: 'center', textAlign: 'right' }}>Bill Amount</th>
                                            <th style={{ padding: '8px', textAlign: 'center', textAlign: 'right' }}>Pending Amount</th>
                                            <th style={{ padding: '8px', textAlign: 'center', textAlign: 'right' }}>Paid Amount</th>
                                            <th style={{ padding: '8px', textAlign: 'center', textAlign: 'right' }}>Bal Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoicedeatils.map((invdetail, index) => (
                                            <tr
                                                key={index}
                                            >
                                                <td style={{ padding: '1px', fontSize: '14px', width: '20%' }}>{invdetail.SaleDescription}</td>
                                                <td style={{ padding: '1px', fontSize: '14px', width: '20%', textAlign: 'right' }}>
                                                    {invdetail.BillAmount}
                                                </td>
                                                <td style={{ padding: '1px', fontSize: '14px', width: '20%', textAlign: 'right' }}>
                                                    {invdetail.SaleAmount}
                                                </td>
                                                <td style={{ padding: '1px', fontSize: '14px', width: '20%', textAlign: 'right' }}>
                                                    {invdetail.Amount}
                                                </td>
                                                <td style={{ padding: '1px', fontSize: '14px', width: '20%', textAlign: 'right' }}>
                                                    {invdetail.BalanceAmount}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </TableContainer>


                        </div>
                    </div>
                </div>


            </div>
        </Fragment>
    );
}

export default ReceiptCreate;
